import type {
  ColDef,
  ValueGetterParams,
  ValueSetterParams,
} from 'ag-grid-community';

// AgGrid's cellDataType:'date' needs a Date OBJECT, but the API serves/accepts
// dates as ISO strings — without conversion the cell renders "Invalid Date".
// Spread this into any editable date column so it renders, edits, and
// round-trips back to a local 'yyyy-MM-dd' string for the API.
//
//   { field: 'expDate', headerName: ..., editable: true, ...dateColumnProps<Asset>('expDate') }
export function dateColumnProps<T>(field: keyof T & string): Partial<ColDef<T>> {
  return {
    cellDataType: 'date',
    valueGetter: (p: ValueGetterParams<T>) => {
      const v = (p.data as Record<string, unknown> | undefined)?.[field];
      return typeof v === 'string' && v ? new Date(v) : ((v as Date) ?? null);
    },
    valueSetter: (p: ValueSetterParams<T>) => {
      if (!p.data) return false;
      const d = p.newValue as Date | null;
      (p.data as Record<string, unknown>)[field] = d
        ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
        : null;
      return true;
    },
  };
}
